/**
 * 自选股
 */

import React from "react"
import ReactDOM from "react-dom"
import { ZXG } from "../components/page/favor/index";

ReactDOM.render(
  <ZXG/>,
  document.getElementById('app')
)